import styled from "@emotion/styled";
export enum ORDER_ENTRY_ZINDEXES {
  DISABLED_OVERLAY = 99,
  VIEW_TRANSACTION = 100,
}

export const DisabledOverlay = styled.div<{ isProcessingTrade?: boolean }>`
  opacity: 0.5;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  border-radius: 36px;
  z-index: ${ORDER_ENTRY_ZINDEXES.DISABLED_OVERLAY};
  cursor: not-allowed;
  background: ${props =>
    props.isProcessingTrade ? "" : props.theme.surface.alt.secondary.default};
`;
